import * as types from './types';
export default {
  [types.SET_WISHLIST_ITEMS](state, payload) {
    var currentState = state;
    currentState.items = payload.products;
  },
  [types.ADD_WISHLIST_ITEM](state, payload) {
    var currentState = state;
    currentState.items.push(payload);
  },
  [types.DELETE_WISHLIST_ITEM](state, payload) {
    var currentState = state;
    currentState.items = currentState.items.filter(i => i.reference !== payload);
  }
};